import { useEffect, useRef, useState } from 'react';
import { ColorRing } from 'react-loader-spinner';

import { useGetTableHubColumns } from './useGetTableHubColumns';
import HubDeviceExpandable from './TableHubExpandable';

import { HubDevice } from 'api/traps/DevicesWareHouse/types';
import FilterDataTable from 'components/FilterDataTable/FilterDataTable';
import useScreenSize from 'hooks/Screen/useScreenSize';
import HubIcon from 'components/Icons/HubIcon';

interface Props {
  data: HubDevice[] | undefined;
  isLoading: boolean;
  isRefetching: boolean;
  refetch: () => void;
  isAll: boolean;
}

const TableHub: React.FC<Props> = ({ isAll, data, isLoading, isRefetching, refetch }) => {
  const [page, setPage] = useState(1);
  const [ordering, setQueryParam] = useState('');
  const [search, setSearch] = useState('');
  const columns = useGetTableHubColumns(isAll);
  const { isNotMobile, isNotLargeDesktop } = useScreenSize();
  const isAllRef = useRef(isAll);

  useEffect(() => {
    refetch();
  }, [page, ordering, search, refetch]);

  return (
    <div className="col-xxl-12 mb-3 px-xl-1">
      {(isLoading || isRefetching) && (
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(255, 255, 255, 0.7)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1001,
          }}
        >
          <ColorRing
            visible
            height="80"
            width="80"
            ariaLabel="color-ring-loading"
            wrapperStyle={{}}
            wrapperClass="color-ring-wrapper"
            colors={['#9C7AE2', '#E27A8C', '#C0E27A', '#7AE2D0', '#F7F18F']}
          />
        </div>
      )}
      <div className="bg-white">
        <FilterDataTable<HubDevice>
          columns={columns}
          data={data || []}
          title="Hubs"
          iconComponent={<HubIcon height={45} />}
          onChangePage={setPage}
          onChangeFilterParams={setQueryParam}
          onChangeSearch={setSearch}
          isLoading={isLoading}
          expandableRows={isAllRef ? isNotLargeDesktop : isNotMobile}
          expandableRowsComponent={row => <HubDeviceExpandable data={row.data} isAll={isAll} />}
        />
      </div>
    </div>
  );
};

export default TableHub;
